import { forwardRef } from 'react';

import PropTypes from 'prop-types';

/**
 * A composer chip: the persistent, cost-relevant settings next to the text field. `on === false`
 * draws a dashed, muted chip for a switched-off source.
 */
const Chip = forwardRef(({ icon: Icon, label, active = false, on, onClick, title, disabled = false }, ref) => {
	let tone = 'border-bgBase-500 bg-white text-text hover:bg-bgBase-300';
	if (on === false) tone = 'border-dashed border-bgBase-600 text-bgBase-800 hover:text-text';
	if (active) tone = 'border-primary-500 bg-primary-500 text-white';
	return (
		<button
			ref={ref}
			type="button"
			onClick={onClick}
			title={title}
			disabled={disabled}
			className={`inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-full border pl-2.5 pr-3 text-xs font-medium transition-colors disabled:opacity-50 ${tone}`}
		>
			<Icon className="h-3.5 w-3.5" />
			{label}
		</button>
	);
});

Chip.displayName = 'Chip';

Chip.propTypes = {
	icon: PropTypes.elementType.isRequired,
	label: PropTypes.string.isRequired,
	active: PropTypes.bool,
	on: PropTypes.bool,
	onClick: PropTypes.func,
	title: PropTypes.string,
	disabled: PropTypes.bool,
};

export default Chip;
